/**
 * Lifecycle status for Ashley Home capabilities.
 * Architecture supports showing planned capabilities before implementation.
 */
export const ASHLEY_CAPABILITY_STATUS = Object.freeze({
  AVAILABLE: "available",
  COMING_SOON: "coming_soon",
  FUTURE: "future",
});

export const ASHLEY_CAPABILITY_STATUS_META = Object.freeze({
  [ASHLEY_CAPABILITY_STATUS.AVAILABLE]: {
    label: "Available",
    indicator: "available",
  },
  [ASHLEY_CAPABILITY_STATUS.COMING_SOON]: {
    label: "Coming Soon",
    indicator: "coming_soon",
  },
  [ASHLEY_CAPABILITY_STATUS.FUTURE]: {
    label: "Future",
    indicator: "future",
  },
});

/**
 * @param {string} status
 * @returns {{ label: string, indicator: string }}
 */
export function getAshleyCapabilityStatusMeta(status) {
  return (
    ASHLEY_CAPABILITY_STATUS_META[status] ||
    ASHLEY_CAPABILITY_STATUS_META[ASHLEY_CAPABILITY_STATUS.AVAILABLE]
  );
}
